import React from 'react'
import { styled } from 'styled-components'

interface LoadingOverlayProps {
  isLoading: boolean
  children?: React.ReactNode
  message?: string
}

const LoadingOverlay = ({
  isLoading = true,
  message = 'Loading...',
}: LoadingOverlayProps): React.ReactNode => {
  return (
    isLoading && (
      <AbsoluteOverlay>
        <div className="loading-overlay d-flex justify-content-center align-items-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">{message}</span>
          </div>
        </div>
      </AbsoluteOverlay>
    )
  )
}

export const LoadingLayer = ({
  isLoading,
  children,
}: LoadingOverlayProps): React.ReactNode => {
  return isLoading ? (
    <SkeletonOverlay>
      <LoadingSpinner />
    </SkeletonOverlay>
  ) : (
    <div>{children}</div>
  )
}

export const LoadingSpinner = () => (
  <div className="loading-overlay d-flex justify-content-center align-items-center">
    <div className="spinner-border" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
)

export default LoadingOverlay

const SkeletonOverlay = styled.div`
  position: relative;

  .loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 5;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.7);
  }

  .spinner-border {
    width: 3rem;
    height: 3rem;
    color: var(--bg-accent-secondary);
  }
`

const AbsoluteOverlay = styled(SkeletonOverlay)`
  position: absolute;
  width: 100%;
  height: calc(100vh - 140px);
  top: 70px;
  left: 0;

  .loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
  }
`
